<rk-button
  variant="secondary"
  (buttonClick)="onAddNewPodcast()"
  [text]="'podcast-config.add' | translate"
  class="mt-8 ml-7 mb-8"
>
</rk-button>
